import React from 'react';

import { SVGPropsType } from 'src/types';

function Up(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="7"
            height="5"
            viewBox="0 0 7 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M6.3125 3.93744L3.5 1.12494L0.6875 3.93744"
                stroke={stroke}
                strokeWidth="1.08395"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default Up;
